






import Vue from "vue";
import { AudioDecoderPlayer } from "@joyz/app-core/utils/audio";

import IconSpeaker from "@joyz/app-core/assets/icons/white/Speaker.svg";
import { audioContext } from "@tt-app/utils/audio/audioContext";

export default Vue.extend({
  name: "AudioElement",

  props: {
    audioDecoderPlayer: {
      type: AudioDecoderPlayer,
      default: undefined
    },
    src: {
      type: String,
      default: undefined
    },
    url: {
      type: String,
      default: undefined
    }
  },

  data() {
    return {
      icons: {
        speaker: IconSpeaker
      }
    };
  },

  methods: {
    async playWordAudio() {
      if (!this.audioDecoderPlayer) return;

      if (this.audioDecoderPlayer.status === "playing") {
        this.audioDecoderPlayer.stop();
      }

      await audioContext.resume();
      await this.audioDecoderPlayer.play(this.src || this.url);
    }
  }
});
